import type { DonneesMaquette } from './scene';

/*
  Les maquettes disponibles, une par serveur campus.

  Leurs fichiers sont ecrits par `tools/maquette-campus.mjs` et partent
  avec l'application ; chacun n'est charge que lorsqu'on ouvre la sienne.
  Ce module ne touche pas a three.js : l'ecran peut savoir qu'une
  maquette existe sans rien charger de lourd.
*/
const fichiers = import.meta.glob<{ default: DonneesMaquette }>('./donnees/*.json');

/** Ce serveur a-t-il sa maquette ? */
export function maquetteExiste(serverId: string): boolean {
  return `./donnees/${serverId}.json` in fichiers;
}

export async function chargerMaquette(serverId: string): Promise<DonneesMaquette | null> {
  const charger = fichiers[`./donnees/${serverId}.json`];
  return charger ? (await charger()).default : null;
}
